import { ActivatedRouteSnapshot } from "@angular/router";
import { getOnboardingStore } from "src/app/core/guards/first-time-user-experience.helper";
import { ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS } from "src/app/shared/constants/websocket-event-types.constants";
import { StoreGetDTO } from "../../store-management/stores/store";
import { OnboardingPotentialCasesResponse } from "../onboarding-modal.service";

export function resolveOnboardingPotentialCasesStoreId(
  route: ActivatedRouteSnapshot,
  stores: StoreGetDTO[] | undefined,
): string {
  return (
    route.queryParamMap.get(
      ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS.STORE_ID,
    ) ??
    getOnboardingStore(stores)?.storeId ??
    ""
  );
}

export function hasOnboardingPotentialCases(
  response: OnboardingPotentialCasesResponse | null | undefined,
): boolean {
  return (response?.potentialCases?.length ?? 0) > 0;
}

export function emptyOnboardingPotentialCasesResponse(
  storeId = "",
): OnboardingPotentialCasesResponse {
  return {
    storeId,
    potentialCases: [],
    totalQuantityPotential: 0,
    totalAmountPotential: 0,
  };
}
